import { Fragment, useEffect, useState } from "react";
import { Flex, Text, Select, Checkbox, Button } from "@theorgchartdev/storybook";
import {
  sectionContainer,
  selectWithLink,
  selectWithLabelStyle,
  sectionTitles,
  linkClass
} from "@/appComponents/Navigation/Header/WebLinkMenu/WebLinkUtils";
import { GetSSOConfigs } from "@/Utils/Promises";
import { OCLink } from "@/appComponents/Blocks/Utils/OCLink";
import { appstr } from "@coreapp/utils/appstr";
import { appstrp } from "@coreapp/utils/appstrp";

const BuildUserOptions = (users, linkType, clickHandler) => {
  let linkUserList = [];
  let options = [];

  if (linkType === "public") {
    linkUserList = users.filter(x => x["ignoreref"] && x["ignoreref"] === true);
  } else if (linkType === "restricted") {
    linkUserList = users.filter(x => x["domainWhitelist"] && x["domainWhitelist"].length > 0);
  }

  for (let user of linkUserList) {
    options.push({
      label: user.email,
      value: user.username, //this is actually userID
      clickHandler: target => clickHandler("linkUser", target.value)
    });
  }

  return options;
};

const LoadEntityIDs = async () => {
  const mapping = await GetSSOConfigs();
  const entityIDs = mapping.filter(x => x["entityID"]).map(x => x["entityID"]);
  return entityIDs;
};

export const LinkUserSection = ({ users, linkType, linkUserConfig, setUrlParamsMgr, setError }) => {
  const samlEnabled = linkUserConfig.saml;
  const [ssoOptions, setSsoOptions] = useState([]);

  useEffect(() => {
    const BuildSsoOptions = async clickHandler => {
      const ssoConfigs = await LoadEntityIDs();
      let options = [];

      for (let idx in ssoConfigs) {
        options.push({
          label: ssoConfigs[idx],
          value: ssoConfigs[idx],
          clickHandler: target => clickHandler("entityID", target.value)
        });
      }

      setSsoOptions(options);
    };

    if (samlEnabled) BuildSsoOptions(SetLinkUser);
  }, [samlEnabled]);

  const SetLinkUser = (key, value) => {
    setUrlParamsMgr(prevState => ({
      ...prevState,
      linkUserConfig: { ...prevState.linkUserConfig, [key]: value }
    }));
    setError(null);
  };

  let publicLinkContent = (
    <Flex {...selectWithLink}>
      <Flex {...selectWithLabelStyle}>
        <Select
          label={appstr("Link user")}
          placeholder={appstrp("Select", "...")}
          inputOnly={false}
          selectSize={"medium"}
          optionsSize={"small"}
          value={linkUserConfig.linkUser}
          options={BuildUserOptions(users, linkType, SetLinkUser)}
          dataTestId={"weblink-linkuser-select"}
        />
      </Flex>
      <Flex padding={"28px 0px 0px"}>
        <OCLink
          to={"/settings/account/authorization"}
          className={linkClass}
          data-testid={"configure-link-user"}
        >
          <Text colorModifier={"theme"} size={"small"}>
            {appstr("Configure link user")}
          </Text>
        </OCLink>
      </Flex>
    </Flex>
  );

  let privateLinkContent = (
    <Flex direction={"column"} gap={"8px"}>
      <Checkbox
        id={"web-link-saml-chkbx"}
        label={appstr("togglesaml")}
        data-testid={"saml-deep-link-chkbx"}
        size={"medium"}
        checked={samlEnabled}
        onToggle={() => {
          SetLinkUser("saml", !samlEnabled);
        }}
      />
      {samlEnabled ? (
        <Flex>
          <Select
            size={"medium"}
            value={linkUserConfig.entityID}
            options={ssoOptions}
            dataTestId={"weblink-sso-entityid-select"}
          />
        </Flex>
      ) : null}
    </Flex>
  );

  return (
    <Fragment>
      <Flex {...sectionContainer}>
        <Text size={"small"} modifier={"bold"}>
          {appstr(sectionTitles.linkuser)}
        </Text>
        {linkType === "private" ? privateLinkContent : publicLinkContent}
      </Flex>
    </Fragment>
  );
};
